import { gql } from "@apollo/client";

export const AssetFilesTotal = gql`
    query AssetFilesTotal ($id: ID!){
        assetLocation (id: $id) {
            id
            asset {
                id
                product {
                    id
                    fileList {
                        total
                    }
                }
            }
            installedBaseNode {
                id
                fileList {
                    total
                }
            }
        }
    }
`;
